import React from 'react';

const FormInput = ({
  id,
  name,
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  error,
  className = '',
  min,
  max,
  step,
  rows,
  disabled = false,
  icon,
  iconPosition = 'right',
  helpText,
  ...props
}) => {
  const inputClasses = `block w-full px-4 py-2 text-gray-700 bg-white border ${
    error ? 'border-red-500' : 'border-gray-300'
  } rounded-lg focus:outline-none focus:ring-2 ${
    error ? 'focus:ring-red-500' : 'focus:ring-primary-500'
  } focus:border-transparent transition-all duration-200 ${
    disabled ? 'bg-gray-100 cursor-not-allowed' : ''
  } ${icon && iconPosition === 'left' ? 'pl-10' : ''} ${
    icon && iconPosition === 'right' ? 'pr-10' : ''
  } ${className}`;

  const renderInput = () => {
    if (type === 'textarea') {
      return (
        <textarea
          id={id}
          name={name}
          value={value || ''}
          onChange={onChange}
          className={inputClasses}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          rows={rows || 3}
          {...props}
        />
      );
    }

    return (
      <input
        id={id}
        name={name}
        type={type}
        value={value || ''}
        onChange={onChange}
        className={inputClasses}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        {...props}
      />
    );
  };

  return (
    <div className="">
      {label && (
        <label
          htmlFor={id}
          className={`block text-sm font-medium mb-1.5 ${
            error ? 'text-red-500' : 'text-gray-700'
          } ${required ? 'after:content-["*"] after:ml-0.5 after:text-red-500' : ''}`}
        >
          {label}
        </label>
      )}
      <div className="relative">
        {icon && iconPosition === 'left' && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        {renderInput()}
        {icon && iconPosition === 'right' && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
      </div>
      {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
      {helpText && !error && <p className="mt-1 text-sm text-gray-500">{helpText}</p>}
    </div>
  );
};

export default FormInput;
